
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import Control from 'ol/control/Control.js';
import { defaults as defaultControls } from 'ol/control.js';

import { fromLonLat, toLonLat } from 'ol/proj';

//Ceci ne marche pas : import imeteo_marker from '../imeteo_marker.png';
//const imeteo_marker = new URL('../imeteo_marker.png', import.meta.url).href;

console.log("✅ map.js chargé");

// TODO Global variable window.* a enlever eventuellement
const lit_cook = window.lit_cook;
const cre_cook = window.cre_cook;
const Get_Data = window.Get_Data;

// Coordonnée initiale

if( lit_cook("lat") != ""){
  window.my_lat = parseFloat(lit_cook("lat"))
}
if( lit_cook("lon") != ""){
  window.my_lng = parseFloat(lit_cook("lon"))
}
if(lit_cook("zoom") != "" ){
  window.my_zoom = parseInt(lit_cook("zoom"));
}
const my_location = fromLonLat([window.my_lng, window.my_lat]);
if(lit_cook("topo") != "" ){
  window.my_topo = parseInt(lit_cook("topo"));
}

// Initialisation de la carte
const map = new Map({
  target: 'map_canvas',
  layers: [
    new TileLayer({
      source: new OSM(),
    }),
  ],
  view: new View({
    center: my_location,
    zoom: window.my_zoom,
  }),
});

// Création de la couche topographique
const topoLayer = new TileLayer({
  source: new XYZ({
    url: 'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
  }),
});

// Création du marqueur initial
const marker = new Feature({
  geometry: new Point(my_location),
});

// Style du marqueur
marker.setStyle(
  new Style({
    image: new Icon({
      //src: 'https://openlayers.org/en/v7.4.0/examples/data/icon.png', // ou ton propre fichier
      src: './imeteo_marker.png',
      anchor: [0.5, 1],
    }),
  })
);

// Ajout du marqueur à la carte
const vectorLayer = new VectorLayer({
  source: new VectorSource({
    features: [marker],
  }),
  zIndex: 10, // Définir un z-index plus élevé pour que la couche marqueur soit au-dessus de la topo
});

map.addLayer(vectorLayer);

window.product=lit_cook("produit");
if(window.product == ""){window.product='temp'}
//Get_Data(window.product)

// Écoute du clic sur la carte pour déplacer le marqueur
map.on('click', function (event) {
  // Coordonnées du clic en projection EPSG:3857 (projection de la carte)
  const coords = event.coordinate;

  // Déplacer le marqueur aux coordonnées du clic
  marker.setGeometry(new Point(coords));

  // Convertir les coordonnées du clic (EPSG:3857) en longitude/latitude (EPSG:4326)
  const lonLat = toLonLat(coords); // Conversion en Lon/Lat

  console.log(`Longitude: ${lonLat[0]}, Latitude: ${lonLat[1]}`); // Afficher dans la console
  window.product=lit_cook("produit");
  if(window.product == ""){window.product='temp'}
  window.my_lng=lonLat[0];
  window.my_lat=lonLat[1];
  cre_cook("lat",lonLat[1],100);
  cre_cook("lon",lonLat[0],100);  
  Get_Data(window.product);

});

map.getView().on('change:resolution', function(event) {
  //console.log('Zoom changed! New resolution:', map.getView().getResolution());
  //console.log('New zoom level:', map.getView().getZoom());
  cre_cook("zoom",map.getView().getZoom(),100);
});

// Créer un bouton personnalisé et l'ajouter dans un contrôle OpenLayers
const topoButton = document.createElement('button');
topoButton.innerHTML = 'Topo';
topoButton.id = 'topo_button';
topoButton.classList.add('ol-control');

// Créer un contrôle OpenLayers avec ce bouton
const topoControl = new Control({
  element: topoButton,
  target: null,  // null permet de ne pas spécifier un élément particulier dans le DOM, mais de le gérer dynamiquement
});

// Ajouter le contrôle à la carte
map.addControl(topoControl);

if (window.my_topo == 1) {
  map.addLayer(topoLayer);  // Ajouter la couche topo
}

// Ajouter un gestionnaire d'événement pour le clic sur le bouton
topoButton.addEventListener('click', function () {
  console.log('Le bouton Topo a été cliqué!');
  // Ajoute ici l'action que tu veux pour le bouton
  if(window.my_topo == 0){
    window.my_topo = 1;
  } else {
    window.my_topo = 0;
  }
  if (window.my_topo == 1) {
    map.addLayer(topoLayer);  // Ajouter la couche topo
    console.log('Couche topographique activée');
  } else {
    map.removeLayer(topoLayer);  // Retirer la couche topo
    console.log('Couche topographique désactivée');
  }
  cre_cook("topo",window.my_topo);
});

export { map, topoButton };
